// src/components/search/useSiteSearchShortcutHint.ts

'use client'

import { useEffect, useState } from 'react'

/**
 * Platform-appropriate keyboard hint for the global site-search palette
 * (`⌘K` on Apple platforms, `Ctrl K` elsewhere), shared by every trigger
 * that opens it so the heuristic can never drift between surfaces
 * (`r3547477910`).
 *
 * SSR/first paint always renders `⌘K`; the hint is corrected after mount
 * because platform detection needs `navigator`, and rendering the detected
 * value during hydration would mismatch the server HTML.
 */
export function useSiteSearchShortcutHint(): string {
  const [shortcutHint, setShortcutHint] = useState('⌘K')

  useEffect(() => {
    const platform = `${navigator.platform ?? ''} ${navigator.userAgent ?? ''}`
    if (!/Mac|iPhone|iPad|iPod/i.test(platform)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- one-shot platform detection; must run client-side to avoid an SSR hydration mismatch
      setShortcutHint('Ctrl K')
    }
  }, [])

  return shortcutHint
}
